import { format, formatDistanceToNow, isValid } from 'date-fns';

/**
 * Safely format a date as a relative time string (e.g. "3 days ago")
 * Returns a fallback string if the date is invalid
 */
export function formatRelativeTime(dateString: string | Date, fallback: string = 'Recently'): string {
  try {
    const date = new Date(dateString);
    if (!isValid(date)) return fallback;
    return formatDistanceToNow(date, { addSuffix: true });
  } catch (error) {
    console.warn('Invalid date:', dateString);
    return fallback;
  }
}

/**
 * Safely format a date using the provided format string
 * Returns a fallback string if the date is invalid
 */
export function formatDateSafely(
  dateString: string | Date, 
  formatStr: string = 'MMM d, yyyy',
  fallback: string = 'Unknown date'
): string {
  try {
    const date = new Date(dateString);
    if (!isValid(date)) return fallback;
    return format(date, formatStr);
  } catch (error) {
    console.warn('Invalid date:', dateString);
    return fallback;
  }
}

/**
 * Check if a date string is valid
 */
export function isValidDateString(dateString: string | Date): boolean {
  try {
    return isValid(new Date(dateString));
  } catch {
    return false;
  }
}